export default __webpack_public_path__ + "static/media/Q10.01a67de8.jpg";